import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { enqueueSnackbar } from './snackbar';
import fetch from '../../api/fetch';

export const listRigs = () => (dispatch) => {
  return fetch
    .post('rigs/fetch')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.RIGS_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.RIGS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const syncEnverusRigs = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.RIGS_SYNC_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  return fetch
    .post('enverus/deleteAndSyncRigs')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      await dispatch(listRigs());
      dispatch({
        type: REDUX_ACTIONS.RIGS_SYNC_IDLE,
        payload: {
          message: data.message,
        },
      });
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing rigs',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.RIGS_SYNC_ERROR,
        payload: {
          message: error.message || 'Error syncing rigs',
        },
      });
    });
};
